import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Уже одобренные (pre-approved) офферы

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventShowPreApprovedOffer = ({
  bankName,
  offerName,
  offerStatus,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Статус предодоба',
  eventLabel: `Пользователь видел предодоб|${bankName}|${offerName}|${offerStatus}`,
  eventValue: undefined,
});

export const eventPreApprovedInitialOfferStatus = ({
  bankName,
  offerName,
  offerStatus,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Статус предодоба',
  eventLabel: `Предодоб|${bankName}|${offerName}|${offerStatus}`,
  eventValue: undefined,
});

export const eventPreApprovedOfferStatusChange = ({
  bankName,
  offerName,
  offerStatus,
  userSaw,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
  userSaw: boolean;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Статус предодоба',
  eventLabel: `Предодоб|Смена статуса|${bankName}|${offerName}|${offerStatus}|видел пользователь - ${userSaw ? 'да' : 'нет'}`,
  eventValue: undefined,
});

export const eventPreApprovedOfferClick = ({
  bankName,
  offerName,
}: {
  bankName: string;
  offerName: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Предодоб|${bankName}|${offerName}`,
  eventValue: undefined,
});

export const eventPreApprovedOfferRedirect = ({
  bankName,
  offerName,
  redirectUrl,
}: {
  bankName: string;
  offerName: string;
  redirectUrl: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Редирект',
  eventLabel: `Предодоб|${bankName}|${offerName}|${redirectUrl}`,
  eventValue: undefined,
});

export const eventPreApprovedMeetingModalShow = ({
  bankName,
  offerName,
  offerStatus,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: `Предодоб|${bankName}|${offerName}|${offerStatus}|Модальное окно Встречи`,
  eventValue: undefined,
});

export const eventPreApprovedMeetingModalClick = ({
  bankName,
  offerName,
  offerStatus,
  action,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
  action: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Предодоб|${bankName}|${offerName}|${offerStatus}|Модальное окно Встречи|${action}`,
  eventValue: undefined,
});

export const eventPreApprovedSmsModalShow = ({
  bankName,
  offerName,
  offerStatus,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ',
  eventLabel: `Предодоб|${bankName}|${offerName}|${offerStatus}|Модальное окно СМС`,
  eventValue: undefined,
});

export const eventPreApprovedSmsModalClick = ({
  bankName,
  offerName,
  offerStatus,
  action,
}: {
  bankName: string;
  offerName: string;
  offerStatus: string;
  action: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик',
  eventLabel: `Предодоб|${bankName}|${offerName}|${offerStatus}|Модальное окно СМС|${action}`,
  eventValue: undefined,
});
